// This can be false if you're using a fallback (i.e. SPA mode)
export const prerender = true;

export const load = () => {
	return {
		buildTime: new Date()
			.toLocaleString('en-GB', {
				day: '2-digit',
				month: 'short',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				hour12: false
			})
			.replace(',', ' at')
	};
};
